/**
 * Utilitário para tradução de mensagens de erro nos services
 * Como os services não podem usar hooks, esta função fornece as traduções
 * baseadas no idioma atual armazenado no localStorage
 */

// Traduções estáticas para evitar dependência de i18next nos services
const errorTranslations = {
  pt: {
    "Erro ao criar usuário": "Erro ao criar usuário",
    "Erro ao listar usuários": "Erro ao listar usuários", 
    "Erro ao atualizar usuário": "Erro ao atualizar usuário",
    "Erro ao deletar usuário": "Erro ao deletar usuário",
    "Erro ao obter saúde do sistema": "Erro ao obter saúde do sistema",
    "Erro ao obter detalhes do usuário": "Erro ao obter detalhes do usuário",
    "Erro ao alterar status do usuário": "Erro ao alterar status do usuário",
    "Erro ao alterar permissões de admin": "Erro ao alterar permissões de admin",
    "Email é obrigatório": "Email é obrigatório",
    "Erro ao obter estatísticas de notificações": "Erro ao obter estatísticas de notificações",
    "Erro ao obter portfolio do usuário": "Erro ao obter portfolio do usuário",
    "Erro ao verificar se o usuário existe": "Erro ao verificar se o usuário existe",
    "Nome de usuário é obrigatório": "Nome de usuário é obrigatório",
    "Dados inválidos": "Dados inválidos",
    "Erro ao processar solicitação": "Erro ao processar solicitação",
    "Erro de conexão. Verifique sua internet e tente novamente.": "Erro de conexão. Verifique sua internet e tente novamente.",
    "Erro ao remover transação do Dynamic Cash": "Erro ao remover transação do Dynamic Cash",
    "RSI e regime são obrigatórios": "RSI e regime são obrigatórios",
    "Regime é obrigatório": "Regime é obrigatório",
    "Erro ao calcular índice de estresse": "Erro ao calcular índice de estresse",
    "Erro ao obter informações do regime": "Erro ao obter informações do regime",
    "Erro ao obter informações de sobrecompra do regime": "Erro ao obter informações de sobrecompra do regime",
    "Erro ao obter informações bidirecionais do regime": "Erro ao obter informações bidirecionais do regime",
    "Erro ao obter informações dos regimes": "Erro ao obter informações dos regimes",
    "Erro ao verificar serviço": "Erro ao verificar serviço",
    "Erro ao calcular recomendações": "Erro ao calcular recomendações",
    "Erro ao calcular fórmula": "Erro ao calcular fórmula",
    "Erro ao obter visão geral das fórmulas": "Erro ao obter visão geral das fórmulas",
    "Erro de conexão. Verifique sua internet.": "Erro de conexão. Verifique sua internet.",
    "Erro de conexão ou inesperado": "Erro de conexão ou inesperado",
    "Erro ao obter informações de regimes": "Erro ao obter informações de regimes",
    "Erro ao atualizar notificação de regime": "Erro ao atualizar notificação de regime",
    "Erro ao carregar configurações": "Erro ao carregar configurações",
    "Erro ao calcular conversão": "Erro ao calcular conversão",
    "Erro ao obter resumo do portfólio": "Erro ao obter resumo do portfólio",
    "Erro ao obter análise do portfólio": "Erro ao obter análise do portfólio",
    "Erro ao obter histórico de transações": "Erro ao obter histórico de transações",
    "Erro ao carregar relatório de desempenho": "Erro ao carregar relatório de desempenho",
    "Formato de resposta inválido": "Formato de resposta inválido",
    "Erro ao obter transações do usuário": "Erro ao obter transações do usuário",
    "Erro ao criar transação": "Erro ao criar transação",
    "Erro ao registrar transação manual": "Erro ao registrar transação manual",
    "Erro ao remover transação": "Erro ao remover transação",
    "Erro ao executar operações": "Erro ao executar operações",
    "Erro ao validar operações": "Erro ao validar operações"
  },
  en: {
    "Erro ao criar usuário": "Error creating user",
    "Erro ao listar usuários": "Error listing users",
    "Erro ao atualizar usuário": "Error updating user", 
    "Erro ao deletar usuário": "Error deleting user",
    "Erro ao obter saúde do sistema": "Error getting system health",
    "Erro ao obter detalhes do usuário": "Error getting user details",
    "Erro ao alterar status do usuário": "Error changing user status",
    "Erro ao alterar permissões de admin": "Error changing admin permissions",
    "Email é obrigatório": "Email is required",
    "Erro ao obter estatísticas de notificações": "Error getting notification statistics",
    "Erro ao obter portfolio do usuário": "Error getting user portfolio",
    "Erro ao verificar se o usuário existe": "Error checking if user exists",
    "Nome de usuário é obrigatório": "Username is required",
    "Dados inválidos": "Invalid data",
    "Erro ao processar solicitação": "Error processing request",
    "Erro de conexão. Verifique sua internet e tente novamente.": "Connection error. Check your internet and try again.",
    "Erro ao remover transação do Dynamic Cash": "Error removing Dynamic Cash transaction",
    "RSI e regime são obrigatórios": "RSI and regime are required",
    "Regime é obrigatório": "Regime is required",
    "Erro ao calcular índice de estresse": "Error calculating stress index",
    "Erro ao obter informações do regime": "Error getting regime information",
    "Erro ao obter informações de sobrecompra do regime": "Error getting regime overbought information",
    "Erro ao obter informações bidirecionais do regime": "Error getting regime bidirectional information",
    "Erro ao obter informações dos regimes": "Error getting regimes information",
    "Erro ao verificar serviço": "Error checking service",
    "Erro ao calcular recomendações": "Error calculating recommendations",
    "Erro ao calcular fórmula": "Error calculating formula",
    "Erro ao obter visão geral das fórmulas": "Error getting formula overview",
    "Erro de conexão. Verifique sua internet.": "Connection error. Check your internet.",
    "Erro de conexão ou inesperado": "Unexpected connection error",
    "Erro ao obter informações de regimes": "Error getting regime information",
    "Erro ao atualizar notificação de regime": "Error updating regime notification",
    "Erro ao carregar configurações": "Error loading configurations",
    "Erro ao calcular conversão": "Error calculating conversion",
    "Erro ao obter resumo do portfólio": "Error getting portfolio summary",
    "Erro ao obter análise do portfólio": "Error getting portfolio analysis",
    "Erro ao obter histórico de transações": "Error getting transaction history",
    "Erro ao carregar relatório de desempenho": "Error loading performance report",
    "Formato de resposta inválido": "Invalid response format",
    "Erro ao obter transações do usuário": "Error getting user transactions",
    "Erro ao criar transação": "Error creating transaction",
    "Erro ao registrar transação manual": "Error registering manual transaction",
    "Erro ao remover transação": "Error removing transaction",
    "Erro ao executar operações": "Error executing operations",
    "Erro ao validar operações": "Error validating operations"
  }
};

/**
 * Traduz uma mensagem de erro baseada no idioma atual
 * @param {string} portugueseMessage - Mensagem em português
 * @returns {string} Mensagem traduzida ou original se não encontrada
 */
export const translateError = (portugueseMessage) => {
  // Pega o idioma atual do localStorage (usado pelo i18next)
  const currentLanguage = localStorage.getItem('i18nextLng') || 'pt';
  
  // Se for português ou não tiver tradução, retorna o original
  if (currentLanguage === 'pt' || !errorTranslations[currentLanguage]) {
    return portugueseMessage;
  }
  
  // Retorna a tradução ou a mensagem original se não encontrar
  return errorTranslations[currentLanguage][portugueseMessage] || portugueseMessage;
};

/**
 * Cria uma mensagem de erro traduzida
 * @param {string} portugueseMessage - Mensagem base em português
 * @param {Error} originalError - Erro original (opcional)
 * @returns {Error} Novo erro com mensagem traduzida
 */
export const createTranslatedError = (portugueseMessage, originalError = null) => {
  const translatedMessage = translateError(portugueseMessage);
  const error = new Error(translatedMessage);
  
  // Preserva informações do erro original se fornecido
  if (originalError) {
    error.originalError = originalError;
    error.stack = originalError.stack;
  }
  
  return error;
};
